module.exports = __webpack_public_path__ + "media/images/icons-c5eb101fca1f32d184ac5e0d270e1af1.svg";